export default {
  // 页面标题
  'products.title': '产品管理',
  'products.statistics': '产品统计概览',
  'products.list': '产品列表',

  // 统计数据
  'products.stats.loading': '统计数据加载中...',
  'products.stats.total': '总产品数',
  'products.stats.inStock': '有库存',
  'products.stats.preorder': '预订',
  'products.stats.outOfStock': '缺货',
  'products.stats.listed': '已上架',
  'products.stats.unlisted': '未上架',
  'products.stats.onSale': '促销中',
  'products.stats.showroomAvailable': '展厅可用',
  'products.stats.matrixTitle': '产品统计对比（类型 × 促销/活动）',
  'products.stats.matrixLoading': '加载对比数据中...',
  'products.stats.matrixEmpty': '暂无对比数据。',
  'products.stats.matrixColumnAll': '全部产品',
  'products.tab.statsComparison': '统计对比',
  'products.tab.productList': '产品列表',

  // 表格列
  'products.table.productInfo': '产品信息',
  'products.table.price': '价格',
  'products.table.compareAtPrice': '划线价',
  'products.table.stockStatus': '库存状态',
  'products.table.listingStatus': '上架状态',
  'products.table.channel': '渠道',
  'products.table.promotionStatus': '促销状态',
  'products.table.promotionLabels': '促销标签',
  'products.table.dealDate': '活动日期',
  'products.table.merchStatus': 'Merch 状态',
  'products.table.category': '分类',
  'products.table.productFamily': '产品族',
  'products.table.extendedAttributes': '扩展属性',
  'products.table.dataComparison': '数据对比',
  'products.table.actions': '操作',

  // 产品状态标签
  'products.status.inStock': '有库存',
  'products.status.preorder': '预订',
  'products.status.outOfStock': '缺货',
  'products.status.listed': '已上架',
  'products.status.unlisted': '未上架',
  'products.status.onSale': '促销中',
  'products.status.noPromotion': '无促销',
  'products.status.showroomAvailable': '展厅可用',
  'products.status.newArrival': '新品',
  'products.status.sameAsSku': '与SKU相同',
  'products.status.expired': '已过期',
  'products.channel.global': 'GLOBAL',
  'products.channel.web': 'Web',
  'products.channel.pos': 'POS',
  'products.channel.default': '默认',

  // 数据对比
  'products.comparison.shopifyVsDear': 'Shopify vs DEAR：',
  'products.comparison.dearVsInno': 'DEAR vs INNO：',
  'products.comparison.stock': '库存',
  'products.comparison.status': '状态',
  'products.comparison.pi': 'PI',
  'products.comparison.allPlatformsSynced': '所有平台已同步',
  'products.comparison.syncRequired': '需要同步',
  'products.comparison.noData': '无数据',

  // 操作
  'products.actions.viewDetails': '查看详情',
  'products.actions.syncInventory': '同步库存',
  'products.actions.export': '导出',
  'products.actions.refresh': '刷新',
  'products.actions.reload': '刷新数据',
  'products.actions.syncMySQL': '从DEAR同步',
  'products.actions.importMetafield': '导入Metafield',

  // 搜索和过滤
  'products.search.placeholder': '搜索产品名称、SKU或条码',
  'products.filter.stockStatus': '库存状态',
  'products.filter.listingStatus': '上架状态',
  'products.filter.promotionStatus': '促销状态',
  'products.filter.vendor': '供应商',

  // 分页
  'products.pagination.items': '项',
  'products.pagination.of': '共',

  // 导入弹窗
  'products.import.title': '导入产品Metafield',
  'products.import.description': '请上传Products.csv或Excel文件，系统将自动解析并导入到MySQL products表。',
  'products.import.supportedFields': '模板列：Variant SKU（必填，即 barcode）、Category，以及各 Metafield 列。请先下载模板照着填。',
  'products.import.downloadTemplate': '下载模板',
  'products.import.downloadTemplateHint': '下载包含正确列格式的CSV模板',
  'products.import.templateDownloaded': '模板下载成功',
  'products.import.selectFile': '选择CSV或Excel文件',
  'products.import.updateExisting': '更新已存在的记录',
  'products.import.startImport': '开始导入',
  'products.import.cancel': '取消',
  'products.import.onlySupport': '只支持CSV和Excel文件（.csv, .xlsx, .xls）',

  // 导入结果
  'products.import.results.total': '总计',
  'products.import.results.inserted': '新增',
  'products.import.results.updated': '更新',
  'products.import.results.failed': '失败',
  'products.import.results.errorDetails': '错误详情：',
  'products.import.results.moreErrors': '个错误...',

  // 消息提示
  'products.message.exportSuccess': '成功导出{count}个产品',
  'products.message.exportFailed': '导出产品失败',
  'products.message.importFailed': '导入失败，请检查文件格式',
  'products.message.selectFile': '请选择CSV或Excel文件',
  'products.message.noData': '暂无数据',
  'products.message.syncStarted': '正在从DEAR同步产品数据...',
  'products.message.syncSuccess': '成功从DEAR同步 {count} 个产品',

  // 导出
  'products.export.filename': 'products_{date}.csv',
};